/**
 * contentTableHeaders contains all the necessary metadata for building the
 * table headers on the /content listing page
 *
 * Behavioral properties
 * clickable - Determines if a TableHeader should use an onClick handler and
 *             adds a css class to the tableHeader
 */
export const contentTableHeaders = {
  default: [
    {
      label: t('contents.index.headers.title'),
      name: 'title',
      size: 'xl',
      clickable: true,
      loadingPlaceholder: {
        width: 55,
        roleTag: true,
      },
    },
    {
      label: t('contents.index.headers.status'),
      name: 'state',
      size: 'l',
      clickable: true,
      classes: {
        hideBelowXS: true,
      },
      loadingPlaceholder: {
        width: 90,
      },
    },
    {
      label: t('contents.index.headers.date'),
      name: 'last-modified',
      size: 'l',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowXS: true,
      },
      loadingPlaceholder: {
        width: 90,
      },
    },
    {
      label: t('contents.index.headers.average_score'),
      name: 'average-score',
      size: 's',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 85,
      },
    },
    {
      label: t('contents.index.headers.times_completed'),
      name: 'completed-count',
      size: 's',
      clickable: false,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 70,
      },
    },
    {
      label: t('contents.index.headers.last_completed'),
      name: 'last-completed',
      size: 's',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 40,
      },
    },
  ],
  journeys: [
    {
      label: t('contents.index.headers.title'),
      name: 'title',
      size: 'xl',
      clickable: false,
      loadingPlaceholder: {
        width: 55,
        roleTag: true,
      },
    },
    {
      label: t('contents.index.headers.status'),
      name: 'state',
      size: 'l',
      clickable: false,
      classes: {
        hideBelowXS: true,
      },
      loadingPlaceholder: {
        width: 90,
      },
    },
    {
      label: t('contents.index.headers.last_updated'),
      name: 'last-modified',
      size: 'l',
      clickable: false,
      sortType: 'numeric',
      classes: {
        hideBelowXS: true,
      },
      loadingPlaceholder: {
        width: 90,
      },
    },
  ],
  content_freshness: [
    {
      label: t('contents.index.headers.content_freshness.title'),
      name: 'title',
      size: 'xl',
      clickable: true,
      loadingPlaceholder: {
        width: 55,
      },
    },
    {
      label: t('contents.index.headers.content_freshness.status'),
      name: 'state',
      size: 'l',
      clickable: true,
      classes: {
        hideBelowXS: true,
      },
      loadingPlaceholder: {
        width: 90,
      },
    },
    {
      label: t('contents.index.headers.content_freshness.date'),
      name: 'last-modified',
      size: 'l',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowXS: true,
      },
      loadingPlaceholder: {
        width: 90,
      },
    },
    {
      label: t('contents.index.headers.content_freshness.last_activity'),
      name: 'last-activity',
      size: 'm',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 85,
      },
    },
    {
      label: t('contents.index.headers.content_freshness.freshness_score'),
      name: 'freshness-score',
      size: 's',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 70,
      },
      // We need to retrieve this translation via a function to ensure
      // that this translation is evaluated at runtime.
      getTooltip: () => t('contents.index.content_freshness.score_description'),
    },
  ],
};

/**
 * peopleTableHeaders contains all the necessary metadata for building the
 * table headers on the /people listing page
 */
export const peopleTableHeaders = [
  {
    label: t('people.index.headers.user'),
    name: 'name',
    size: 'xl',
    clickable: true,
    loadingPlaceholder: {
      width: 55,
      roleTag: true,
    },
  },
  {
    label: t('people.index.headers.date_created'),
    name: 'last-modified',
    size: 'l',
    clickable: true,
    sortType: 'numeric',
    classes: {
      hideBelowXS: true,
    },
    loadingPlaceholder: {
      width: 90,
    },
  },
  {
    clickable: false,
    label: t('people.index.headers.average_score'),
    name: 'average-score',
    size: 's',
    sortType: 'numeric',
    classes: {
      hideBelowMD: true,
      center: true,
    },
    loadingPlaceholder: {
      width: 85,
    },
  },
  {
    label: t('people.index.headers.recent_activity'),
    name: 'recent-activity',
    size: 's',
    clickable: true,
    sortType: 'numeric',
    classes: {
      hideBelowMD: true,
      center: true,
    },
    loadingPlaceholder: {
      width: 70,
    },
  },
  {
    label: t('people.index.headers.last_completion'),
    name: 'last-completed',
    size: 's',
    clickable: true,
    sortType: 'numeric',
    classes: {
      hideBelowMD: true,
      center: true,
    },
    loadingPlaceholder: {
      width: 40,
    },
  },
];
